import { render, staticRenderFns } from "./TimeTable.vue?vue&type=template&id=6884ade1"
import script from "./TimeTable.vue?vue&type=script&lang=js"
export * from "./TimeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6884ade1')) {
      api.createRecord('6884ade1', component.options)
    } else {
      api.reload('6884ade1', component.options)
    }
    module.hot.accept("./TimeTable.vue?vue&type=template&id=6884ade1", function () {
      api.rerender('6884ade1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/painel/TimeTable.vue"
export default component.exports